
import Vue from 'vue'
import ProductPreviewModal from '@/categories/components/ProductPreviewModal.vue'
import { APP_EVENTS } from '@/common/constants'
import eventBus from '@/common/utils/eventBus'
import { BQ_EVENT_NAMES, raksulBQEventTracker } from '@/common/utils'

export default Vue.extend({
  components: {
    ProductPreviewModal
  },
  data() {
    return {
      isProductPreviewModalOpen: false,
      initProductId: '',
      productGroupIds: []
    }
  },
  mounted() {
    eventBus.$on(APP_EVENTS.SHOW_PRODUCT_QUICK_PREVIEW, (initProductId: string, productGroupIds: string[]) => {
      this.isProductPreviewModalOpen = true
      this.initProductId = initProductId
      this.productGroupIds = productGroupIds
      this.sendBQEvents(initProductId)
    })
  },
  methods: {
    closeModal() {
      this.isProductPreviewModalOpen = false
    },
    sendBQEvents(productId: string) {
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.PRODUCT_PREVIEW_BTN_CLICK,
        data: {
          product_id: productId,
          path: window.location.pathname
        }
      })
    }
  }
})
